<template>
  <div class="organization-info">
    <el-descriptions :column="2" border size="small">
      <template #title>
        <div class="title-row">
          <el-tooltip content="返回集团列表" placement="bottom">
            <el-button
              class="back-btn"
              type="primary"
              plain
              circle
              @click="goOrganizationList"
            >
              <el-icon><ArrowLeft /></el-icon>
            </el-button>
          </el-tooltip>
          <div class="desc-title">集团信息</div>
        </div>
      </template>
      <el-descriptions-item label="ID">
        {{ organization?.id || "-" }}
      </el-descriptions-item>
      <el-descriptions-item label="名称">
        <template v-if="!isEditingName">
          <span>{{ organization?.name || "-" }}</span>
          <el-button
            v-if="organization"
            type="primary"
            link
            style="margin-left: 8px"
            @click="startEditName"
            >编辑</el-button
          >
        </template>
        <template v-else>
          <el-input
            v-model="editName"
            size="small"
            placeholder="请输入集团名称"
            style="max-width: 240px; margin-right: 8px"
          />
          <el-button
            type="primary"
            size="small"
            :loading="savingName"
            @click="saveName"
            >保存</el-button
          >
          <el-button size="small" @click="cancelEditName">取消</el-button>
        </template>
      </el-descriptions-item>
    </el-descriptions>

    <div class="tabs-panel">
      <el-tabs v-model="activeTab">
        <el-tab-pane label="客户列表" name="users">
          <div class="panel-actions">
            <el-button type="primary" @click="openCreateUserDrawer"
              >开通集团管理员账号</el-button
            >
          </div>
          <el-table
            v-loading="loadingUsers"
            class="data-table"
            :data="userList"
            border
            height="100%"
            size="small"
            stripe
            highlight-current-row
          >
            <el-table-column fixed type="index" label="ID" min-width="40" />
            <el-table-column fixed prop="name" label="姓名" min-width="120" />
            <el-table-column prop="username" label="用户名" min-width="140" />
            <el-table-column prop="phone" label="电话" min-width="120" />
            <el-table-column prop="email" label="邮箱" min-width="180" />
            <el-table-column prop="company" label="公司" min-width="140" />
            <el-table-column prop="department" label="部门" min-width="120" />
            <el-table-column prop="address" label="地址" min-width="180" />
            <el-table-column prop="country" label="国家" min-width="100" />
            <el-table-column prop="person" label="联系人" min-width="120" />
            <el-table-column
              prop="description"
              label="描述"
              min-width="200"
              show-overflow-tooltip
            />
            <el-table-column
              prop="createtime"
              label="创建时间"
              min-width="160"
            />
            <el-table-column
              prop="updatetime"
              label="更新时间"
              min-width="160"
            />
            <el-table-column fixed="right" label="操作" width="100">
              <template #default="{ row }">
                <el-button type="primary" link @click="goUserInfo(row)"
                  >查看详情</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>

        <el-tab-pane label="船舶列表" name="ships">
          <div class="panel-actions">
            <el-button type="primary" @click="openCreateShipDrawer"
              >新增船舶</el-button
            >
          </div>
          <el-table
            v-loading="loadingShips"
            class="data-table"
            :data="shipList"
            border
            height="100%"
            size="small"
            stripe
            highlight-current-row
          >
            <el-table-column fixed type="index" label="ID" min-width="40" />
            <el-table-column
              fixed
              prop="ship.name"
              label="名称"
              min-width="140"
            />
            <el-table-column
              prop="status.cname"
              label="在线状态"
              min-width="100"
            />
            <el-table-column
              prop="ship.ccsCertificationId"
              label="CCS证书ID"
              min-width="160"
            />
            <el-table-column
              prop="ship.projectId"
              label="项目ID"
              min-width="140"
            />
            <el-table-column
              prop="ship.deliveryDate"
              label="交付日期"
              min-width="140"
            />
            <el-table-column
              prop="ship.createtime"
              label="创建时间"
              min-width="160"
            />
            <el-table-column
              prop="ship.updatetime"
              label="更新时间"
              min-width="160"
            />
            <el-table-column
              prop="ship.description"
              label="描述"
              min-width="200"
              show-overflow-tooltip
            />
            <el-table-column fixed="right" label="授权时间" width="160">
              <template #default="{ row }">
                <p v-if="row.authorization">
                  {{ $d(new Date(row.authorization.startTime), "long") }}
                </p>
                <p v-if="row.authorization">
                  {{ $d(new Date(row.authorization.endTime), "long") }}
                </p>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="授权状态" width="80">
              <template #default="{ row }">
                <p
                  class="authorization-status-text"
                  :class="getAuthorizationStatusClass(row.authorization)"
                >
                  {{ getAuthorizationStatus(row.authorization) }}
                </p>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="100">
              <template #default="{ row }">
                <el-button
                  v-if="row.authorization"
                  type="primary"
                  :disabled="row.authorization.status != 1"
                  link
                  @click="goShipInfo(row)"
                >
                  查看详情
                </el-button>
                <el-button
                  v-else
                  type="success"
                  link
                  @click="applyAuthorization(row)"
                >
                  获取授权
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-dialog
            v-model="applyAuthorizationDialogVisible"
            :title="$t('UIV.applyAuthorization')"
            :before-close="handleApplyAuthorizationDialogClose"
            width="500"
          >
            <el-result
              v-if="applyShipAuthorizationSubmitResult == 1"
              icon="success"
              :title="$t('UIV.success.title')"
              :sub-title="$t('UIV.success.tip')"
            >
              <template #extra>
                <el-button type="primary" @click="closeShipAuorizationDialog">
                  {{ $t("UIV.close") }}
                </el-button>
              </template>
            </el-result>
            <el-result
              v-else-if="applyShipAuthorizationSubmitResult == 0"
              icon="error"
              :title="$t('UIV.failed.title')"
              :sub-title="$t('UIV.failed.tip')"
            >
              <template #extra>
                <el-button type="primary" @click="closeShipAuorizationDialog">
                  {{ $t("UIV.close") }}
                </el-button>
              </template>
            </el-result>
            <div v-else class="apply-authorization-dialog-container">
              <h1>{{ selectedShip?.name }}</h1>
              <el-select
                v-model="applyShipAuthorizationParams.authorityId"
                :placeholder="$t('UIV.selectShipAuthority')"
              >
                <el-option
                  v-for="item in shipAuthorityList"
                  :key="item.id"
                  :label="getName(item)"
                  :value="item.id"
                />
              </el-select>
              <el-date-picker
                v-model="datetimeRange"
                style="width: 100%"
                type="datetimerange"
                :shortcuts="shortcuts"
                range-separator="To"
                start-placeholder="Start date"
                end-placeholder="End date"
              />
              <el-input
                v-model="applyShipAuthorizationParams.description"
                :placeholder="$t('UIV.descriptionPlaceHolder')"
                type="textarea"
                rows="5"
                resize="none"
                style="margin-top: 20px"
              />
              <el-button
                style="width: 100%; margin-top: 20px"
                type="primary"
                :loading="btnSubmitShipAuthorizationApplyLoading"
                @click="submitShipAuthorizationApply"
              >
                {{ $t("UIV.submitShipAuthorizationApply") }}
              </el-button>
            </div>
          </el-dialog>
        </el-tab-pane>
      </el-tabs>
    </div>

    <!-- 开通集团管理员账号抽屉（创建的是用户端集团账号，非管理端登录账号） -->
    <el-drawer
      v-model="userDrawer.visible"
      title="开通集团管理员账号"
      size="420px"
      :with-header="true"
      :close-on-click-modal="!userDrawer.loading"
      :close-on-press-escape="!userDrawer.loading"
      :before-close="onUserDrawerBeforeClose"
      direction="rtl"
      append-to-body
    >
      <el-alert
        type="info"
        :closable="false"
        show-icon
        style="margin-bottom: 16px"
      >
        <template #title>
          此处创建的是<b>用户端集团管理员账号</b>（交付给客户集团登录用户端使用），
          并非管理端登录账号。账号创建后交由客户，本集团其他账号（区域管理员 /
          普通账号）由客户在用户端自行创建。
        </template>
      </el-alert>
      <el-form
        ref="userFormRef"
        :model="userForm"
        :rules="userRules"
        label-width="96px"
        status-icon
      >
        <el-form-item label="姓名" prop="name">
          <el-input
            v-model="userForm.name"
            :disabled="userDrawer.loading"
            placeholder="请输入姓名"
          />
        </el-form-item>
        <el-form-item label="用户名" prop="username">
          <el-input
            v-model="userForm.username"
            :disabled="userDrawer.loading"
            placeholder="8-20位，字母数字和._-"
          />
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input
            v-model="userForm.password"
            :disabled="userDrawer.loading"
            show-password
            placeholder="8-20位，允许常见符号"
          />
        </el-form-item>
        <el-form-item label="确认密码" prop="re_password">
          <el-input
            v-model="userForm.re_password"
            :disabled="userDrawer.loading"
            show-password
            placeholder="再次输入密码"
          />
        </el-form-item>

        <el-form-item label="电话" prop="phone">
          <el-input
            v-model="userForm.phone"
            :disabled="userDrawer.loading"
            placeholder="选填"
          />
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input
            v-model="userForm.email"
            :disabled="userDrawer.loading"
            placeholder="选填，邮箱格式"
          />
        </el-form-item>
        <el-form-item label="部门" prop="department">
          <el-input
            v-model="userForm.department"
            :disabled="userDrawer.loading"
            placeholder="选填"
          />
        </el-form-item>
        <el-form-item label="地址" prop="address">
          <el-input
            v-model="userForm.address"
            :disabled="userDrawer.loading"
            placeholder="选填"
          />
        </el-form-item>
        <el-form-item label="联系人" prop="person">
          <el-input
            v-model="userForm.person"
            :disabled="userDrawer.loading"
            placeholder="选填"
          />
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input
            v-model="userForm.description"
            :disabled="userDrawer.loading"
            type="textarea"
            :rows="3"
            placeholder="选填"
          />
        </el-form-item>

        <div class="drawer-footer">
          <el-button
            type="success"
            :loading="userDrawer.loading"
            @click="createUser"
            >提交</el-button
          >
          <el-button
            type="danger"
            :disabled="userDrawer.loading"
            @click="onUserDrawerCancel"
            >取消</el-button
          >
        </div></el-form
      >
    </el-drawer>

    <!-- 新增船舶抽屉 -->
    <el-drawer
      v-model="shipDrawer.visible"
      title="新增船舶"
      size="420px"
      :with-header="true"
      :close-on-click-modal="!shipDrawer.loading"
      :close-on-press-escape="!shipDrawer.loading"
      :before-close="onShipDrawerBeforeClose"
      direction="rtl"
      append-to-body
    >
      <el-form
        ref="shipFormRef"
        :model="shipForm"
        :rules="shipRules"
        label-width="120px"
        status-icon
      >
        <el-form-item label="名称" prop="name">
          <el-input
            v-model="shipForm.name"
            :disabled="shipDrawer.loading"
            placeholder="请输入名称（必填）"
          />
        </el-form-item>
        <el-form-item label="CCS证书ID" prop="ccsCertificationId">
          <el-input
            v-model="shipForm.ccsCertificationId"
            :disabled="shipDrawer.loading"
            placeholder="选填"
          />
        </el-form-item>
        <el-form-item label="项目ID" prop="projectId">
          <el-input
            v-model="shipForm.projectId"
            :disabled="shipDrawer.loading"
            placeholder="选填"
          />
        </el-form-item>
        <el-form-item label="交付日期" prop="deliveryDate">
          <el-date-picker
            v-model="shipForm.deliveryDate"
            :disabled="shipDrawer.loading"
            type="date"
            placeholder="选填"
            value-format="YYYY-MM-DD"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input
            v-model="shipForm.description"
            :disabled="shipDrawer.loading"
            type="textarea"
            :rows="3"
            placeholder="选填"
          />
        </el-form-item>

        <div class="drawer-footer">
          <el-button
            type="success"
            :loading="shipDrawer.loading"
            @click="createShip"
            >提交</el-button
          >
          <el-button
            type="danger"
            :disabled="shipDrawer.loading"
            @click="onShipDrawerCancel"
            >取消</el-button
          >
        </div>
      </el-form>
    </el-drawer>
  </div>
</template>
<script lang="ts" setup>
import { fetchOrganizationInfoApi } from "@/api/organization/organizationApi";
import { getName } from "@/util/i18nUtil";
import {
  fetchOrganizationShipListApi,
  createShipApi,
  submitShipAuthorizationApplyApi,
  getShipAuthorityListApi,
} from "@/api/productApi";
import { fetchUserListApi, createUserApi } from "@/api/user/userApi";
import { Organization } from "@/types/organization";
import {
  ApplyShipAuthorizationParams,
  Ship,
  ShipAuthorization,
  ShipVO,
} from "@/types/product";
import { User } from "@/types/user";
import { computed, onMounted, reactive, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import type { FormInstance, FormRules } from "element-plus";
import { ElMessage } from "element-plus";
import { useI18n } from "vue-i18n";
import { Authority } from "@/types/resource";
import { formatToIsoOffset } from "@/util/datetimeUtil";

const { t } = useI18n();
const route = useRoute();
const router = useRouter();
const orgId = computed(() => route.query.orgId as string);

const organization = ref<Organization>();
const isEditingName = ref(false);
const editName = ref("");
const savingName = ref(false);

const activeTab = ref("users");

const fetchOrganizationInfo = async () => {
  const response = await fetchOrganizationInfoApi(orgId.value);
  if (response) {
    organization.value = response;
  }
};

const userList = ref<User[]>([]);
const loadingUsers = ref(false);
const fetchUserList = async () => {
  loadingUsers.value = true;
  try {
    const response = await fetchUserListApi(orgId.value);
    if (response) {
      userList.value = response;
    }
  } finally {
    loadingUsers.value = false;
  }
};

const shipList = ref<ShipVO[]>([]);
const loadingShips = ref(false);
const fetchShipList = async () => {
  loadingShips.value = true;
  try {
    const response = await fetchOrganizationShipListApi(orgId.value);
    if (response) {
      shipList.value = response;
    }
  } finally {
    loadingShips.value = false;
  }
};

// 编辑名称交互
const startEditName = () => {
  if (!organization.value) return;
  editName.value = organization.value.name;
  isEditingName.value = true;
};

const cancelEditName = () => {
  isEditingName.value = false;
};

const saveName = async () => {
  if (!organization.value) return;
  savingName.value = true;
  try {
    await editOrgInfo();
    organization.value.name = editName.value;
    isEditingName.value = false;
  } finally {
    savingName.value = false;
  }
};

// 详情跳转
const goUserInfo = (row: User) => {
  router.push({ name: "userInfo", query: { userId: row.id } });
};

const goShipInfo = (row: Ship) => {
  router.push({ name: "shipInfo", query: { shipId: row.id } });
};

const editOrgInfo = async () => {
  // TODO
};

const createShip = async () => {
  if (!shipFormRef.value) return;
  await shipFormRef.value.validate(async (valid) => {
    if (!valid) return;
    shipDrawer.value.loading = true;
    try {
      const payload = {
        orgId: orgId.value,
        name: shipForm.value.name,
        ccsCertificationId: shipForm.value.ccsCertificationId || undefined,
        projectId: shipForm.value.projectId || undefined,
        deliveryDate: shipForm.value.deliveryDate || undefined,
        description: shipForm.value.description || undefined,
      } as unknown as Ship;

      const ok = await createShipApi(payload);
      if (ok) {
        ElMessage.success("新增成功");
        shipDrawer.value.visible = false;
        resetShipForm();
        fetchShipList();
      } else {
        ElMessage.error("新增失败");
      }
    } catch (e) {
      ElMessage.error("新增失败");
    } finally {
      shipDrawer.value.loading = false;
    }
  });
};

// 开通集团账号抽屉与表单（创建的是用户端集团账号，非管理端登录账号）
const userDrawer = ref({ visible: false, loading: false });
const userFormRef = ref<FormInstance>();
const userForm = ref({
  orgId: orgId.value,
  name: "",
  username: "",
  password: "",
  re_password: "",
  role: null as unknown as number | null,
  phone: "",
  email: "",
  department: "",
  address: "",
  person: "",
  description: "",
});

const usernamePattern = /^[A-Za-z0-9._-]{8,20}$/; // 字母数字及 . _ -
const passwordPattern = /^[A-Za-z0-9!@#$%^&*()_+\-=.]{8,20}$/; // 常见符号，禁止空格

const validateConfirm = (
  rule: any,
  value: string,
  callback: (e?: Error) => void
) => {
  if (!value) return callback(new Error("请再次输入密码"));
  if (value !== userForm.value.password)
    return callback(new Error("两次输入密码不一致"));
  callback();
};

const userRules: FormRules = {
  name: [
    { required: true, message: "请输入姓名", trigger: "blur" },
    { min: 1, max: 255, message: "长度不超过255字节", trigger: "blur" },
  ],
  username: [
    { required: true, message: "请输入用户名", trigger: "blur" },
    {
      pattern: usernamePattern,
      message: "8-20位，字母数字和._-，不含空格",
      trigger: ["blur", "change"],
    },
  ],
  // 角色规则已删除：开户固定为集团管理员（role=1），表单不再提供角色选择
  password: [
    { required: true, message: "请输入密码", trigger: "blur" },
    {
      pattern: passwordPattern,
      message: "8-20位，允许字母数字及常见符号，不含空格",
      trigger: ["blur", "change"],
    },
  ],
  re_password: [
    { required: true, message: "请再次输入密码", trigger: "blur" },
    { validator: validateConfirm, trigger: ["blur", "change"] },
  ],
  phone: [{ max: 255, message: "长度不超过255字节", trigger: "blur" }],
  email: [
    { type: "email", message: "邮箱格式不正确", trigger: ["blur", "change"] },
    { max: 255, message: "长度不超过255字节", trigger: "blur" },
  ],
  department: [{ max: 255, message: "长度不超过255字节", trigger: "blur" }],
  address: [{ max: 255, message: "长度不超过255字节", trigger: "blur" }],
  person: [{ max: 255, message: "长度不超过255字节", trigger: "blur" }],
  description: [{ max: 255, message: "长度不超过255字节", trigger: "blur" }],
};

const resetUserForm = () => {
  userForm.value = {
    orgId: orgId.value,
    name: "",
    username: "",
    password: "",
    re_password: "",
    phone: "",
    email: "",
    department: "",
    address: "",
    person: "",
    role: null,
    description: "",
  };
  userFormRef.value?.clearValidate();
};

// 新增船舶抽屉与表单
const shipDrawer = ref({ visible: false, loading: false });
const shipFormRef = ref<FormInstance>();
const shipForm = ref({
  orgId: orgId.value,
  name: "",
  ccsCertificationId: "",
  projectId: "",
  deliveryDate: "",
  description: "",
});

const getUtf8ByteLength = (str: string): number => {
  try {
    return new TextEncoder().encode(str).length;
  } catch (e) {
    // 兜底（极端环境）
    return unescape(encodeURIComponent(str)).length;
  }
};

const validateShipName = (
  rule: any,
  value: string,
  callback: (e?: Error) => void
) => {
  if (!value) return callback(new Error("请输入名称"));
  if (/\s/.test(value)) return callback(new Error("名称不能包含空格"));
  if (getUtf8ByteLength(value) > 255)
    return callback(new Error("长度不超过255字节"));
  callback();
};

const validateMax255 = (
  rule: any,
  value: string,
  callback: (e?: Error) => void
) => {
  if (value && getUtf8ByteLength(value) > 255)
    return callback(new Error("长度不超过255字节"));
  callback();
};

const shipRules: FormRules = {
  name: [
    { required: true, message: "请输入名称", trigger: "blur" },
    { validator: validateShipName, trigger: ["blur", "change"] },
  ],
  ccsCertificationId: [{ validator: validateMax255, trigger: "blur" }],
  projectId: [{ validator: validateMax255, trigger: "blur" }],
  deliveryDate: [],
  description: [{ validator: validateMax255, trigger: "blur" }],
};

const resetShipForm = () => {
  shipForm.value = {
    orgId: orgId.value,
    name: "",
    ccsCertificationId: "",
    projectId: "",
    deliveryDate: "",
    description: "",
  };
  shipFormRef.value?.clearValidate();
};

const openCreateShipDrawer = () => {
  resetShipForm();
  shipDrawer.value.visible = true;
};

const onShipDrawerBeforeClose = (done: () => void) => {
  if (shipDrawer.value.loading) return; // 提交中禁止关闭
  done();
};

const onShipDrawerCancel = () => {
  if (shipDrawer.value.loading) return;
  shipDrawer.value.visible = false;
};

const openCreateUserDrawer = () => {
  resetUserForm();
  userDrawer.value.visible = true;
};

const onUserDrawerBeforeClose = (done: () => void) => {
  if (userDrawer.value.loading) return; // 提交中禁止关闭
  done();
};

const onUserDrawerCancel = () => {
  if (userDrawer.value.loading) return;
  userDrawer.value.visible = false;
};

const createUser = async () => {
  if (!userFormRef.value) return;
  await userFormRef.value.validate(async (valid) => {
    if (!valid) return;
    userDrawer.value.loading = true;
    try {
      const payload = {
        orgId: orgId.value,
        name: userForm.value.name,
        username: userForm.value.username,
        password: userForm.value.password,
        // 开户固定为集团管理员（后端同样强制 role=1，双保险）
        role: 1,
        phone: userForm.value.phone || undefined,
        email: userForm.value.email || undefined,
        department: userForm.value.department || undefined,
        address: userForm.value.address || undefined,
        person: userForm.value.person || undefined,
        description: userForm.value.description || undefined,
        company: "",
        country: "",
      } as unknown as User;

      const ok = await createUserApi(payload);
      if (ok) {
        ElMessage.success("添加成功");
        userDrawer.value.visible = false;
        resetUserForm();
        fetchUserList();
      } else {
        ElMessage.error("添加失败");
      }
    } catch (e) {
      ElMessage.error("添加失败");
    } finally {
      userDrawer.value.loading = false;
    }
  });
};

// 船只授权
const shipAuthorityList = ref<Authority[]>([]);
const fetchShipAuthorityList = async () => {
  const response = await getShipAuthorityListApi();
  if (response) shipAuthorityList.value = response;
};

const selectedShip = ref<Ship>();
const applyShipAuthorizationParams = reactive<ApplyShipAuthorizationParams>({
  shipId: "",
  startTime: "",
  endTime: "",
  authorityId: null,
  description: "",
  orgId: orgId.value,
});
const applyAuthorization = async (ship: ShipVO) => {
  console.log(ship.id);
  selectedShip.value = ship.ship;
  applyShipAuthorizationParams.shipId = ship.id;
  applyAuthorizationDialogVisible.value = true;
};

// 提交授权请求
const applyAuthorizationDialogVisible = ref<boolean>(false);
const datetimeRange = ref<[Date, Date] | []>([]);
watch(datetimeRange, (value) => {
  if (Array.isArray(value) && value.length === 2) {
    applyShipAuthorizationParams.startTime = formatToIsoOffset(value[0]);
    applyShipAuthorizationParams.endTime = formatToIsoOffset(value[1]);
  } else {
    applyShipAuthorizationParams.startTime = "";
    applyShipAuthorizationParams.endTime = "";
  }
});
const shortcuts = [
  {
    text: t("UIV.threeHours"),
    value: () => {
      const start = new Date();
      const end = new Date();
      end.setHours(end.getHours() + 3);
      return [start, end];
    },
  },
  {
    text: t("UIV.oneDay"),
    value: () => {
      const start = new Date();
      const end = new Date();
      end.setDate(end.getDate() + 1);
      return [start, end];
    },
  },
  {
    text: t("UIV.oneWeek"),
    value: () => {
      const start = new Date();
      const end = new Date();
      end.setDate(end.getDate() + 7);
      return [start, end];
    },
  },
  {
    text: t("UIV.oneMonth"),
    value: () => {
      const start = new Date();
      const end = new Date();
      end.setMonth(end.getMonth() + 1);
      return [start, end];
    },
  },
];
const btnSubmitShipAuthorizationApplyLoading = ref<boolean>(false);
const applyShipAuthorizationSubmitResult = ref<number>();
const submitShipAuthorizationApply = async () => {
  const params = applyShipAuthorizationParams;
  if (params.shipId == "") {
    applyShipAuthorizationSubmitResult.value = 0;
    return;
  }
  if (params.startTime == "") {
    ElMessage.error(t("UIV.warning.selectStartTime"));
    return;
  }
  if (params.endTime == "") {
    ElMessage.error(t("UIV.warning.selectEndTime"));
    return;
  }
  if (params.authorityId == null) {
    ElMessage.error(t("UIV.warning.selectAuthority"));
    return;
  }
  btnSubmitShipAuthorizationApplyLoading.value = true;
  const response = await submitShipAuthorizationApplyApi(
    applyShipAuthorizationParams
  );
  btnSubmitShipAuthorizationApplyLoading.value = false;
  console.log(response);
  if (response === "ok") {
    applyShipAuthorizationSubmitResult.value = 1;
    fetchShipList();
  } else {
    applyShipAuthorizationSubmitResult.value = 0;
  }
};

// 关闭Dialog窗口
const closeShipAuorizationDialog = () => {
  handleApplyAuthorizationDialogClose(() => {
    applyAuthorizationDialogVisible.value = false;
  });
};

// 处理Dialog关闭事件
const handleApplyAuthorizationDialogClose = (done: () => void) => {
  done();
  setTimeout(() => {
    selectedShip.value = undefined;
    datetimeRange.value = [];
    Object.assign(applyShipAuthorizationParams, {
      authorityId: null,
      endTime: "",
      shipId: "",
      startTime: "",
      description: "",
      orgId: orgId.value,
    });
    btnSubmitShipAuthorizationApplyLoading.value = false;
    applyShipAuthorizationSubmitResult.value = undefined;
  }, 300);
};

const getAuthorizationStatus = (
  authorization: ShipAuthorization | undefined
) => {
  if (!authorization) return t("UIV.unauthorized");
  if (authorization.status == 0) return t("UIV.unauthorized");
  else if (authorization.status == 1) return t("UIV.authorized");
  else return t("UIV.authorizing");
};
const getAuthorizationStatusClass = (
  authorization: ShipAuthorization | undefined
) => {
  if (!authorization) return "text-red";
  if (authorization.status == 0) return "text-red";
  else if (authorization.status == 1) return "text-green";
  else return "text-yellow";
};

const goOrganizationList = () => {
  router.push({ name: "organizationList" });
};

onMounted(() => {
  fetchOrganizationInfo();
  fetchUserList();
  fetchShipList();
  fetchShipAuthorityList();
});
</script>
<style lang="less" scoped>
.organization-info {
  --title-font: "Segoe UI", "PingFang SC", "Microsoft YaHei", "Helvetica Neue",
    Arial, sans-serif;
  --body-font: "Segoe UI", "PingFang SC", "Microsoft YaHei", "Helvetica Neue",
    Arial, sans-serif;
  padding: 16px 20px 24px;
  display: flex;
  flex-direction: column;
  height: 100%;
  box-sizing: border-box;
}

.desc-title {
  font-family: var(--title-font);
  font-weight: 800;
  font-size: 18px;
  color: #1f2d3d;
  letter-spacing: 0.3px;
}

.title-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* Descriptions typography */
:deep(.el-descriptions__label) {
  font-family: var(--body-font);
  color: #5e6d82;
  font-weight: 600;
}
:deep(.el-descriptions__content) {
  font-family: var(--body-font);
  color: #2b2f36;
}
:deep(.el-descriptions) {
  margin-bottom: 12px;
}

/* Tabs appearance */
:deep(.el-tabs__item) {
  font-family: var(--body-font);
}
:deep(.el-tabs__item.is-active) {
  font-weight: 700;
  color: #409eff;
}
:deep(.el-tabs__nav-wrap::after) {
  height: 0; /* subtle, cleaner header */
}

/* Table enhancements */
.data-table {
  --table-header-bg: #f7f9fc;
  flex: 1;
  min-height: 0;
}
:deep(.data-table .el-table__header th) {
  background-color: var(--table-header-bg);
  color: #3a4a5a;
  font-weight: 700;
  font-family: var(--body-font);
}
:deep(.data-table .el-button.is-link) {
  font-weight: 600;
}

.panel-actions {
  display: flex;
  justify-content: flex-start;
  gap: 8px;
  margin: 8px 0 10px;
}

.drawer-footer {
  display: flex;
  justify-content: flex-start;
  gap: 8px;
  padding-top: 8px;
}

/* Make tabs section fill remaining height */
.tabs-panel {
  margin-top: 16px;
  flex: 1;
  min-height: 0;
  display: flex;
  overflow: hidden;
}

:deep(.tabs-panel .el-tabs) {
  /* keep Element Plus default layout; just size */
  height: 100%;
  width: 100%;
}

:deep(.tabs-panel .el-tabs__content) {
  /* allow content to grow and scroll within */
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
  display: flex;
}

:deep(.tabs-panel .el-tab-pane) {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.apply-authorization-dialog-container {
  & > div {
    margin-bottom: 20px;
  }
}
.authorization-status-text {
  font-weight: bolder;
  font-family: "SimHei" !important;
  letter-spacing: 1px;
}
.text-red {
  color: rgb(255, 85, 85);
}
.text-green {
  color: rgb(61, 228, 61);
}
.text-yellow {
  color: rgb(221, 202, 27);
}
</style>
